import PromotedSection from './promoted-section'

export default PromotedSection
